import React, { Component } from 'react'
import Table from 'react-bootstrap/lib/Table'
import acc from 'accounting'

import ListFeeItem from './list-fee-item'

class ListFees extends Component {

  render() {
    const { items, isShow } = this.props
    let total = 0

    return (
      <Table condensed hover className="payment">
        <thead>
          <tr>
            <th width="10"></th>
            <th>Code</th>
            <th>Description</th>
            <th className="text-right">Acct Code</th>
            <th className="text-right">Amount (Php)</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, k) => {
            if (item.get('fee_id')) {
              total += item.get('amount') - 0
            }
            return (
              <ListFeeItem
                key={k}
                k={k}
                item={item}
                isShow={isShow}
              />
            )
          })}
        </tbody>
        <tfoot>
          <tr>
            <th colSpan="4" className="text-right">TOTAL AMOUNT:</th>
            <td className="text-right">{acc.formatNumber(total, 2)}</td>
          </tr>
        </tfoot>
      </Table>
    )
  }
}

export default ListFees



// WEBPACK FOOTER //
// ./src/containers/Payments/list-fees.js